<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    

      
      
      
    </base-header>

    <!--start container-->
    <div class="container-fluid mt--6">
    		
            
            
   	 <div v-if="displayIncorpForm==0 && displayIncorpForm==0 " class="row justify-content-center">
     	<div class="col-x-3" style="padding:10px;">
     	
     		<card style="min-height:350px;min-width:300px;text-align:center;cursor:pointer;padding:5px 20px 50px 20px;" >
     			<div  @click="startIncorpForm">
     				<div  style="width:110px;height:110px;" class="icon  icon-shape bg-gradient-success text-white shadow rounded-circle">
     					<i class="ni ni-spaceship " style="font-size:45px;"></i>
     				</div>
     				
     				<div style="margin-top:30px;"><!-- start: body-->
     					<div class="pt-4 text-center">
						  <h5 class="h3 title">
							<span class="d-block mb-1" >Start A New Company</span>
							<small class="h4 font-weight-light text-muted">Incorporation & Company Secretary</small>
						  </h5>
						  </div>
						  
						  <div style="margin-top:30px;">
						  	<h1 class="text-warning heading-title" style="font-size:32px;">$795</h1> 
						  	<h5 class="text-muted">PER YEAR</h5>
						  </div>
     				
     				</div><!-- end: body-->     				
     			</div>

     		</card>
		</div>
		
		<div class="col-x-3"  style="padding:10px">
     		<card style="min-height:350px;min-width:300px;text-align:center;cursor:pointer;padding:5px 20px 50px 20px;">
     			<div   @click="startAppointForm">
     				<div  style="width:110px;height:110px;" class="icon  icon-shape bg-gradient-warning text-white shadow rounded-circle">
     					<i class="fa fa-user-edit " style="font-size:45px;"></i>
     				</div>
     				
     				<div style="margin-top:30px;"><!-- start: body-->
     					<div class="pt-4 text-center">
						  <h5 class="h3 title">
							<span class="d-block mb-1">Appoint Us As Secretary</span>
							<small class="h4 font-weight-light text-muted">Company Secretary</small>
						  </h5>
						  </div>
						  
						  <div style="margin-top:30px;">
						  	<h1 class="text-warning heading-title" style="font-size:32px;">$550</h1> 
						  	<h5 class="text-muted">PER YEAR</h5>
						  </div>
     				
     				</div><!-- end: body-->     				
     			</div>

     		</card>
		</div>



       </div><!-- end row-->
       
       
    
    
    
    <!-- start form wizard row -->
    <div v-if="displayIncorpForm" class="row justify-content-center">
    
        	 <div class="col-xl-8">
        	 
        	 <base-alert v-if="!verified" type="danger" icon="ni ni-like-2">
          		 <i class="fa fa-exclamation-circle"></i><span  @click="resendVerifyEmail" style="cursor:pointer;"> Please verify your email address. Click to resend the verification email. </span>
            </base-alert>
            
            
        	 <card>
        	     <form-wizard
        	     shape="tab"
        	     color="#172b4d"
        	     ref="onboarding_wiz"
        	     >
        	      <template slot="step" slot-scope="props">
        <wizard-step :tab="props.tab"
        :transition="props.transition"
        :key="props.tab.title"
        :index="props.index">
        </wizard-step>
      </template>
      
        	      <h2 slot="title">Start A New Singapore Company</h2>   
        	     
        	     
				  <tab-content title="Company Details"  icon="fa fa-building" :before-change="goToMembersTab">
				     <validation-observer v-slot="{handleSubmit}" ref="formValidator">
				   <form class="needs-validation"
				   					ref="company_d_form"
          						@submit.prevent="handleSubmit(validateCompanyDetails)">
          
				  <div class="row" style="margin-top:80px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Key Information</h3>	
						 </div>
					 </div>
					 
				  <card style="">
				  	<div class="row">
					  <div class="col-xl-6" style="margin-top:20px;"> 
					  <base-input label="Preferred Company Name" placeholder="Enter the preferred name for your company" name="company name"  
					  		  :rules="{required: true}"
					 			  v-model="company.name">
					    <small slot="append" class="font-weight-bold">Pte Ltd</small>
					  </base-input>
					  </div><!-- end col-->
					   <div class="col-xl-6" style="margin-top:auto;margin-bottom:auto;line-height:17px;padding-top:9px;">
					 <a href="/#/name-checker" target="_blank" style="font-size:12px;text-decoration:underline">
					 Use our company name checker to see if your preferred name is available</a>
					  </div>
					  
					  
					  </div><!-- end first row-->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					 	 
					 	 <label class="form-control-label">SSIC Code Of Primary Business Activity</label>  &nbsp;
					 	  <el-tooltip content="Singapore Standard Industrial Classification (SSIC)" placement="top">
					 		  <i class="fa fa-info-circle "/>
					 	   </el-tooltip>
					  							  		
					  		<vue-bootstrap-typeahead
								class="mb-4"
								v-model="query"
								:data="users"
								:serializer="item => item.title_and_code"
								@hit="ssic_info = $event"
								placeholder="Search by describing your business"
							  />
							  
							
							<base-input label="Selected SSIC Code" disabled v-model="ssic_info.code"/>
							<base-input label="Selected SSIC Title" disabled v-model="ssic_info.title"/>

					 	</div>
					 		  <div class="col-xl-6" style="margin-top:auto;margin-bottom:auto;line-height:17px;padding-top:9px;">
					 <a href="https://www.singstat.gov.sg/standards/standards-and-classifications/ssic" target="_blank" style="font-size:12px;text-decoration:underline">
					 Find out more about SSIC</a>
					  </div>
					 	
					 	
					  </div> <!-- end row -->
					  
					    <div class="row">
					 	 <div class="col-xl-9" style="margin-top:20px;"> 
     						  <base-input label="	Business Nature"
     						    :rules="{required: true}" name="business nature"
     						  >
					  		 <textarea class="form-control" id=""
					  		
					  		  v-model="company.business_nature" placeholder="Describe you business in more detail" rows="3"></textarea>
					  		   </base-input>
					 	</div>
					  </div><!-- end row -->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-9" style="margin-top:50px;"> 
					 	 	<label class="form-control-label">
        						Source Of Funds For Running This Company
     						 </label> 
     						 <span class="text-warning" style="font-size:10px;"> * Select at least one</span>
							<br/><br/>
							 
								 <input type="checkbox" v-model="company.sources_arr" value="personal_savings" id="personal_savings" class="mb-3" style="margin-right:11px;">
									<label for="personal_savings" style="font-size:15px;"> Personal Savings</label> <br/>
									
							  	
							  	 <input type="checkbox" v-model="company.sources_arr" value="loans_family" id="loan_family" class="mb-3" style="margin-right:11px;">
									<label for="loan_family" style="font-size:15px;"> Loans (friends and family)</label><br/>
										

							  	 <input type="checkbox" v-model="company.sources_arr" value="loans_bank" id="loan_bank" class="mb-3" style="margin-right:11px;">
							  	 	<label for="loan_bank" style="font-size:15px;"> Loans (banks and other financial institutions)</label>	<br/>
							  
							  <input type="checkbox" v-model="company.sources_arr" value="inheritance" id="inheritance"  class="mb-3"  style="margin-right:11px;">
										<label for="inheritance" style="font-size:15px;">Inheritance </label>	<br/>
										
							  	 <input type="checkbox" v-model="company.sources_arr" value="investors" id="investors" class="mb-3" style="margin-right:11px;">
									<label for="investors" style="font-size:15px;">	Investors</label>	<br/>
									
							  	 <input type="checkbox" v-model="company.sources_arr" value="profit_investment" id="profit_investment" class="mb-3"  style="margin-right:11px;">
									<label for="profit_investment" style="font-size:15px;">	Profits From Investments Or Businesses</label>	<br/>
							  
					 	</div>
					  </div> <!-- end row -->
					  
					  
					  
					  
					  
				   </card>
				
				
				<!-- start address row-->		
					<div class="row" style="margin-top:100px;margin-bottom:20px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Company Address (Singapore)</h3>	
						 </div>
					 </div>
					 
					 <div class="row">
					  <div class="col-xl-6"  @click="toggleUseEasilyAddress" >
					 	<card  v-if="!hasOwnAddress" gradient="info">
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;padding-bottom:20px;padding-top:10px;">
					 	 	<i class="ni ni-check-bold " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
					 				You are using our Registered Address In Singapore As Your Company Address
					 			</h4></div>
					 	 	 </div>
					 		</div>
						 </card>
						 
						 <card  v-if="hasOwnAddress" >
					 		<div class="row">
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div><i class="fa fa-home text-success" style="font-size:45px;margin-bottom:30px;margin-top:20px;"></i></div>
					 	 	 	<h4 > 
					 				Click To Use our Registered Address In Singapore As Your Company Address. Inclusive of our Digital Mailbox service. 
					 			</h4>
					 			<span style="font-size:28px;" class="heading-title text-warning">$200 </span><h5 class="text-muted">PER YEAR</h5>
					 	 	 </div>
					 		</div>
						 </card>
						 
						 
						 
					 </div>
					 </div>
					 
					 
					 <div v-if="hasOwnAddress" class="row" style="margin-top:30px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">Use Your Own Address</h3>	
						 </div>
					 </div>
					 
					  <card v-if="hasOwnAddress">
				
					  
					   <div  class="row">
					   
                 		 <div class="col-md-6">
					    		<base-input label="Address Line 1" placeholder="" 
					    		 name="address line 1"
					    		v-model="company.address_1"/>
					  	 </div>
					  	 <div class="col-md-6">
					    		<base-input label="Address Line 2" placeholder="optional" v-model="company.address_2"/>
					  	 
					  	 </div>
					  	</div><!-- end row-->
					   <div  class="row">
					   		<div v-if="0" class="col-md-3">
					   			<base-input label="City" placeholder="" v-model="company.city"/>
                 		 	</div>
                 		 	<div class="col-md-5">
					   			<base-input label="Postal Code" placeholder=""   name="postal code" v-model="company.zipcode"/>
                 		 	</div>
                 		 	
                 		 	<div class="col-md-5">

                 			 <base-input label="Country">
							  <el-select v-model="company.country" filterable
										 placeholder="Select The Country">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
							
                    		</div>
                 		</div><!-- end row-->
                 		
                 		<div class="row">
					   		
                 		</div><!-- end row-->
                    
                 		
                 		 
                 		 
                 		<div style="min-height:100px;"></div>
					  	 </card>
					  	  <div style="float:right;"><base-button  type="default" native-type="submit">Next</base-button></div>
					  	 </form>
					  	   </validation-observer>
					  	   
					  	    
					  	   
					  	   
				  </tab-content>
				  
				  
				  
				  <tab-content title="Directors & Shareholders" icon="fa fa-users">
				  
				   <validation-observer v-slot="{handleSubmit}" ref="formValidator2">
				   <form class="needs-validation"
				   					ref="company_d_form"
          						@submit.prevent="handleSubmit(validateMembersDetails)">
          						
          						
					 <div class="row" style="margin-top:80px;padding-left:15px;">
						 <div class="col-xl-6">
							 <h3 style="font-size:20px;">About Yourself</h3>	
						 </div>
					 </div>
					 
				  <card style="">
				  
				   <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="First Name"    :rules="{required: true}" name="first name" v-model="person.first_name"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="Last Name (Surname/Family Name)"  v-model="person.last_name"/>
					 	</div>
					  </div> <!-- end row -->
					  
				    <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="NRIC / FIN / National Identification Number" :rules="{required: true}" name="identification number"   v-model="person.gov_id"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="Contact Number" :rules="{required: true}" name="contact number"  v-model="person.contact_number"/>
					 	</div>
					  </div> <!-- end row -->
					  
					
					<div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Nationality">
							  <el-select v-model="person.nationality" filterable
										 placeholder="Select Your Country">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		
					 	</div>
					  </div> <!-- end row -->
					  
					  
					  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Your Position In The New Company">
							  <el-select v-model="person.position" filterable
										 placeholder="Select from the following">
								<el-option v-for="option in selects.positions"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		
					 	</div>
					  </div> <!-- end row -->
					</card>
					
					
					<div class="row" style="margin-top:100px;padding-left:15px;">
						 <div class="col-xl-12">
							 <h3 style="font-size:20px;">Company Director(s)</h3>	
					  	</div>
					</div>
					<card>
					 <div class="row" style="margin-top:0px;padding-left:10px;">
						 <div class="col-xl-12">						 
						 
						<div style="text-align:left;margin-bottom:30px;"><p>In Singapore, every company must have at least one director that is a local resident. This director can be a 
						Singapore Citizen, a Singapore Permanent Resident or a foreigner with a valid pass who is residing in Singapore. 
					    <br/><br/>You may also use our nominee director service to fill this position.
					   </p>
					   </div>
					   </div>
					 </div>
					 
					 
					 <div class="row">
					  <div class="col-xl-6" v-if="person.position=='d' || person.position=='ds'" >
					 
					 	<card gradient="success" >
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;;">
					 	 	<i class="fa fa-user-tie " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
					 				You are a director of {{company.name}} Pte Ltd
					 			</h4></div>
					 	 	 </div>
					 		</div>
						</card>
					 </div><!-- end col-->
						<div  v-for="(d, index) in people_array" :key="index" class="row" style="width:100%;margin-left:auto;margin-right:auto;">
						<div v-if="d.is_director==1" class="col-xl-12">
						<card  gradient="success">
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;;">
					 	 	<i class="fa fa-user-tie " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
										{{d.first_name}} {{d.last_name}}
					 			</h4></div>
					 	 	 </div>
					 	 	  <div class="col-md-2" style="text-align:right;">
					 	 	 	<i class="ni ni-fat-remove" style="font-size:40px;color:#fff" @click="removeDirector(index)" />
							 </div>
					 	 	 
					 		</div>
							</card>
							</div>	
						</div><!-- end col-->
						
						
					 
				
					 </div><!-- end row-->
					 
					 
					 
					 
					   
					<div class="row">
					  <div class="col-xl-6"  @click="toggleUseEasilyDirector" >
					 	<card  v-if="!hasOwnLocalDirector" gradient="info">
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;padding-bottom:20px;padding-top:10px;">
					 	 	<i class="fa fa-user-tie " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
					 				You are using our Nominee Director Service
					 			</h4></div>
					 	 	 </div>
					 		</div>
						 </card>
						 
						 <card  v-if="hasOwnLocalDirector" >
					 		<div class="row">
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div><i class="fa fa-user-tie text-info" style="font-size:45px;margin-bottom:30px;margin-top:20px;"></i></div>
					 	 	 	<h4 > 
					 				Click To Use our Nominee Director Service
					 			</h4>
					 			<span style="font-size:28px;" class="heading-title text-warning">$2000 </span><h5 class="text-muted">PER YEAR</h5>
					 	 	 </div>
					 		</div>
						 </card>
						 
						 
						 
					 </div>
					 </div>
					 
					 
					 
					  
					   
				
					 <div class="card" style="margin-top:20px;">
					    <div class="card-header border-0 bg-gradient-default" @click="toggleAddDirectorForm">
						  <div class="row align-items-center">
							<div class="col">
							  <h3 class="mb-0 text-white">Add A Director</h3>
							</div>
							<div class="col text-right">
							  <base-button type="warning" size="sm"  >+</base-button>
							</div>
						  </div>
						</div>
						<!-- end header -->
    
    
					    <div v-if="displayAddDirectorForm" class="card-body"><!-- start add director form-->
					      <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="First Name"  v-model="director.first_name"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="Last Name (Surname/Family Name)"  v-model="director.last_name"/>
					 	</div>
					  </div> <!-- end row -->
					  
					  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Nationality">
							  <el-select v-model="director.nationality" filterable
										 placeholder="Select Your Country">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	
					 	
					 	<div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Is this director also a shareholder?">
							  <el-select v-model="director.is_shareholder" 
										 placeholder="Please select an option">
								<el-option v-for="option in selects.yesno"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	
					  </div> <!-- end row -->
					  <base-button block type="primary" @click.prevent="addDirector">Add Director</base-button>
					  </div><!-- end add director form-->
					    
					    
					   </div> <!-- end card -->
					
					
					
					</card>
					
					 <div class="row" style="margin-top:120px;padding-left:15px;">
						 <div class="col-xl-12">
							 <h3 style="font-size:20px;">Company Shareholder(s)</h3>	
						</div>
					</div>
					
					<card>
					   
					    <div class="row" style="margin-top:0px;padding-left:10px;">
						 <div class="col-xl-12">
							 
						<div style="text-align:left;margin-bottom:30px;"><p>At least one shareholder is required.
					   </p>
					   </div>
					   </div>
					 </div>
					 
					 
					 <div class="row" style="">
					  <div class="col-xl-6" v-if="person.position=='s' || person.position=='ds'" >
					 
					 	<card gradient="warning" >
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;;">
					 	 	<i class="fa fa-users " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
					 				You are a shareholder of {{company.name}} Pte Ltd
					 			</h4></div>
					 	 	 </div>
					 		</div>
						</card>
					 </div><!-- end col-->
						<div  v-for="(d, index) in people_array"  :key="index" class="row" style="width:100%;margin-left:auto;margin-right:auto;">
						<div v-if="d.is_shareholder==1" class="col-xl-12" >
						<card  type="warning">
					 		<div class="row">
					 	 	<div class="col-md-2" style="text-align:center;;">
					 	 	<i class="fa fa-users " style="font-size:42px;color:#fff"></i>
					 	 	</div>
					 	 	 <div class="col" style="text-align:center;">
					 	 	 <div style="padding-top:10px;">	<h4 class="text-white mb-0"> 
										{{d.first_name}} {{d.last_name}}
					 			</h4></div>
					 	 	 </div>
					 	 	  <div class="col-md-2" style="text-align:right;">
					 	 	 	<i class="ni ni-fat-remove" style="font-size:40px;color:#fff;" @click="removeShareholder(index)" />
							 </div>
					 		</div>
						</card>
						</div>
						</div><!-- end col-->
						
						
					 
				
					 </div><!-- end row-->
					 
					
				
					 <div class="card" style="margin-top:20px;">
					    <div class="card-header border-0 bg-gradient-default" @click="toggleAddShareholderForm">
						  <div class="row align-items-center">
							<div class="col">
							  <h3 class="mb-0 text-white">Add A Shareholder</h3>
							</div>
							<div class="col text-right">
							  <base-button type="warning" size="sm"  >+</base-button>
							</div>
						  </div>
						</div>
						<!-- end header -->
    
    
					    <div v-if="displayAddShareholderForm" class="card-body"><!-- start add shareholder form-->
					      <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="First Name"  v-model="shareholder.first_name"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="Last Name  (Surname/Family Name)"  v-model="shareholder.last_name"/>
					 	</div>
					  </div> <!-- end row -->
					  
					  <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Nationality">
							  <el-select v-model="shareholder.nationality" filterable
										 placeholder="Select Your Country">
								<el-option v-for="option in countries"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	
					  </div> <!-- end row -->
					  <base-button block type="primary" @click.prevent="addShareholder">Add Shareholder</base-button>
					  </div><!-- end add director form-->
					    
					    
					   </div> <!-- end card -->
					   
					  
					 
					  
				 </card>
				 	 <div class="row">
				 	 	<div class="col-xl-2" style="text-align:left;"> 
				 	 		<base-button  type="default" @click.prevent="goBack">Back</base-button>
				 	 	</div>
					 	 <div class="col-xl-6" style="padding-left:25px;font-size:14px;"> 
				 		<span class="text-warning">After saving, you will be required to upload supporting documents and complete the necessary details.</span>
				 		</div>
				 		
				 		 <div class="col-xl-4" style="text-align:right;margin-top:80px;"> 
							 <div style=""><base-button  type="default" native-type="submit">Save & Proceed</base-button></div>				 		
						</div>
				 	</div>
				 
				 
						 </form>
					  	  </validation-observer>
				   </tab-content>
				   <tab-content title="Payment" icon="ni ni-spaceship">
					 re-directing
					 
					 
					 
					 
					 
					 
					 
					 
					 <div class="row">
				 	 	<div class="col-xl-2" style="text-align:right;"> 
				 	 		<base-button  type="default" @click.prevent="goBack">Back</base-button>
				 	 	</div>
				 	 </div>
				   </tab-content>
				   
				   <template slot="footer" slot-scope="props">
					  	       <div class="wizard-footer-left">
								   <wizard-button style="display:none;" v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>
								</div>
								<div class="wizard-footer-right"  style="display:none;">
								  <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Go Next</wizard-button>

								  <wizard-button v-else @click.native="alert('Done')" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>
								</div>
					 </template>
					  	    
					  	    
				</form-wizard>
    			</card>
       
      		 </div><!-- end col -->
    </div>
    <!-- end form wizard row -->
    
    
       
    </div>  <!--End container-->
    
    
    

    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
   import { Select, Option } from 'element-ui'
  
  import {FormWizard, TabContent, WizardButton, WizardStep} from 'vue-form-wizard'
  import  '@/components/FormWizard/vue-form-wizard.min.css'
  
   import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
   
   
  export default {
    components: {
  		FormWizard, TabContent, WizardButton, WizardStep,
  		 [Select.name]: Select,
     	 [Option.name]: Option,
     	 VueBootstrapTypeahead
     	 
    },
    data() {
      return {
     	 query: '',
      	 ssic_info:{
      	 	code:'',
      	 	title:'',
      	 	title_and_code:'',
      	 },
      	 users: [],
      
      	 search_ssic:{
      	 	term:'',
      	 
      	 },
      	 verified: 1,
     	 displayIncorpForm:0,
     	 displayAppointForm:0,
     	 displayAddDirectorForm: false,
     	 displayAddShareholderForm: false,
     	 hasOwnAddress: true,
     	 invoice:[],
     	 people_array:[],
     	 shareholder: {
     	 	nationality:"SG",
     	 	first_name:'',
     	 	last_name:'',
     	 },
     	 director: {
     	 	nationality:"SG",
     	 	is_shareholder:0,
     	 	first_name:'',
     	 	last_name:'',
     	 },
     	 model:{
     	 	directors:[],
     	 	shareholders:[],
     	 	hasOwnAddress:true,
     	 	hasOwnLocalDirector: true,
     	 	person:[],
     	 	company:[],
     	 },
     	 directors_array:[] ,
     	 shareholders_array:[] ,
     	 hasOwnLocalDirector: true,
     	 person:{
     	 	nationality:"SG",
     	 	position: "d",
     	 
     	 },
     	 company:{
     	 	country:"SG",
     	 	sources_arr: [],
     	 	address_1:'',
     	 	address_2:'',
     	 	zipcode:'',
     	 	name:'',
     	 	ssic:'',
     	 	ssic_title:'',
     	 	business_nature:'',
     	 	/*sources:{
     	 		personal_savings:false,
     	 		loans_bank: false,
     	 		loans_family: false,
     	 		inheritance: false,
     	 		investors: false,
     	 		profit_investment: false,
     	 	},*/
     	 },
     	 countries:[],
     	 selects: {
          countries: [
            {value: 'SG', label: 'Singapore'},
		   ],
			yesno: [
            {value: 1, label: 'Yes'},
             {value: 0, label: 'No'},
		   ],
		    positions: [
            {value: 'd', label: 'Director'},
            {value: 's', label: 'Shareholder'},
            {value: 'ds', label: 'Director & Shareholder'},
		   ],
		},
	
      };
    },
    
    watch: {
    // When the query value changes, fetch new results from
    // the API - in practice this action should be debounced
    query(newQuery) {
   		 if(this.selectedUser){
   			 console.log("selectedU:"+this.selectedUser.code);
    	}
    	this.search_ssic.term = newQuery;
    	let uri = this.$base_url+'/api/v1/c/search_ssic';
			 ApiService.post(uri, this.search_ssic).then(response => {
			 	this.users = response.data.results;
			 })
    
    
    }
  },
  
  filters: {
    stringify(value) {
      return JSON.stringify(value, null, 2)
    }
  },
  
    methods: {
     resendVerifyEmail(index) {
          swal.showLoading();
      	 let uri = this.$base_url+'/api/v1/c/resend_verify_email'
         ApiService.get(uri).then(response => {
         	  swal.fire({
						title: `Success`,
						text: 'Verification email resent. If you have not seen it, please check your spam or junk folder. ',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-success',
						icon: 'success'
				 });
         	
   
      	})

      },
     startAppointForm(){
    		this.$router.push( 'onboarding-appoint-form');
     },
      startIncorpForm() {
      		swal.showLoading();
      		this.displayIncorpForm = 1;
      		
      		const vm = this;
      		
      		let uri = this.$base_url+'/api/v1/c/get_init_onboarding';
      		
			 ApiService.post(uri, this.model).then(response => {
			 	this.countries = response.data.countries;
			 	this.verified = response.data.verified;
			 	
				if(response.data.invoice){
					let c = response.data.company;
					this.company.name = c.entity_name;
					
					
					this.company.ssic = c.activity_1_code;
					this.company.business_nature = c.activity_1_desc;
					
					this.ssic_info.code =  c.activity_1_code;
					this.ssic_info.title = c.activity_1_title;
					
					this.company.sources_arr =c.sources_arr;
					this.hasOwnAddress = c.own_address;
					this.hasOwnLocalDirector = c.own_local_director;
					
					this.company.address_1 = c.address_1;
					this.company.address_2 = c.address_2;
					this.company.zipcode = c.zipcode;
					
					
										
					
					this.invoice = response.data.invoice;
					
					response.data.people.forEach(function(p) {
						
						if(p.is_client==1){
							vm.person.first_name = p.first_name;
							vm.person.last_name = p.last_name;
							vm.person.gov_id = p.gov_id;
							vm.person.nationality = p.nationality;
							vm.person.contact_number = p.contact_number;
							
							if(p.is_director && p.is_shareholder){
								vm.person.position ="ds";
							}
							else if(p.is_director){
								vm.person.position ="d";
							}
							else if(p.is_shareholder){
								vm.person.position ="s";
							}
							else{
								vm.person.postion = "c";
							}
						}
						
						if(p.is_client!=1){
							var pp ={
									first_name: p.first_name,
									last_name: p.last_name,
									nationality: p.nationality,
									is_director: p.is_director,
									is_shareholder: p.is_shareholder,
							 };
							 
							 vm.people_array.push(pp);
						 }
						
						
						
						
						if(p.is_client!=1 && p.is_director==1  && p.is_shareholder==1) {
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 1,
								is_shareholder:1
							};
							vm.directors_array.push(pp);
							vm.shareholders_array.push(pp);
						}
						
						else if(p.is_client!=1  && p.is_director!=1  && p.is_shareholder==1){
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 0,
								is_shareholder:1
							};
						
							vm.shareholders_array.push(pp);
						}
						else if(p.is_client!=1  && p.is_director==1 && p.is_shareholder!=1){
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 1,
								is_shareholder:0
							};
						
							vm.directors_array.push(pp);
						}
						
						
						
						
					});//end foreach
					
					//this.$router.push( '/view-invoice/'+	this.invoice.id);
					
					//this.$refs.onboarding_wiz.changeTab(0,2);
				}
				
				
				swal.close();
			}) 
			
			
			
      },
      toggleAddDirectorForm(){
      	if(this.displayAddDirectorForm == true){
      		this.displayAddDirectorForm = false;
      	}
      	else{
      		this.displayAddDirectorForm = true;
      	}
      	
      },
       toggleAddShareholderForm(){
      	if(this.displayAddShareholderForm == true){
      		this.displayAddShareholderForm = false;
      	}
      	else{
      		this.displayAddShareholderForm = true;
      	}
      	
      },
      toggleUseEasilyAddress(){
      
      	if(this.hasOwnAddress== true){
      		this.hasOwnAddress = false;
      	}
      	else{
      		this.hasOwnAddress = true;
      	}
      },
       toggleUseEasilyDirector(){
      
      	if(this.hasOwnLocalDirector== true){
      		this.hasOwnLocalDirector = false;
      	}
      	else{
      		this.hasOwnLocalDirector = true;
      	}
      },
      goToMembersTab(){
      	 // this.$refs.company_d_form.submit();
      	 // return this.companyDetailsCorrect;
      	return true;
      },
     goBack(){
      
      		this.$refs.onboarding_wiz.prevTab();
      },
      checkSameName(checking){
      		var no_same_person = true;
      		this.people_array.forEach(function(p) {
      			if(p.first_name.toUpperCase().trim() == checking.first_name.toUpperCase().trim()
      				&& p.last_name.toUpperCase().trim() == checking.last_name.toUpperCase().trim()){
      				swal.fire({
							title: `Oops`,
							text: "You have already added this person. If both person have the exact same name, please kindly add the letter 'B' to the end of one of their names.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					no_same_person = false;
      			}//end if
      		});
      		
        if(this.person.first_name.toUpperCase().trim() == checking.first_name.toUpperCase().trim()
      				&& this.person.last_name.toUpperCase().trim() == checking.last_name.toUpperCase().trim()){
      				swal.fire({
							title: `Oops`,
							text: "You have already added this person. If both person have the exact same name, please kindly add the letter 'B' to the end of one of their names.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					no_same_person = false;
         }//end if	
      		
      	return no_same_person;
      },
      addDirector(){
		
      		if(this.checkSameName(this.director) == false){
      			return false;
      		}
      		
      		
      		
      		if(!this.director.first_name){
      			swal.fire({
							title: `Oops`,
							text: "Please enter the name of this person.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      		}
      		
      		
      		
      		if(this.director.is_shareholder == 1){
      			
      			this.director.is_shareolder = 1;
      		}
      		else{
      			this.director.is_shareolder = 0;
      		}
      		
      		this.director.is_director = 1;

      		let t = JSON.parse(JSON.stringify(this.director));
    		this.people_array.push(t);
      		
      		
    		
    		this.toggleAddDirectorForm();
    		this.director.first_name = '';
    		this.director.last_name = '';
    		this.director.is_shareholder = 0;
    		
      
      },
       addShareholder(){
       		
      		
       		if(this.checkSameName(this.shareholder) == false){
      			return false;
      		}
      		
       		if(!this.shareholder.first_name){
      			swal.fire({
							title: `Oops`,
							text: "Please enter the name of this person.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      		}
      		
      		
      		
       		this.shareholder.is_director = 0;
       		this.shareholder.is_shareholder = 1;
      		let t = JSON.parse(JSON.stringify(this.shareholder));
    		this.people_array.push(t);
    		
    		this.toggleAddShareholderForm();
    		this.shareholder.first_name = '';
    		this.shareholder.last_name = '';
      
      },
      removeDirector(index){
      	this.removingAlert();
      	this.people_array.splice(index, 1);
      	
      },
      removeShareholder(index){
      	this.removingAlert();
      	this.people_array.splice(index, 1);
      	
      
      },
      removingAlert(){
      		swal.fire({
							title: "Notice",
							text: "This person will be removed as director and/or shareholder.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      
      },
    
      async validateMembersDetails(){
      		var passed = true;
      		var error_msg = "";
      		
      		var director_count = 0;
      		var shareholder_count = 0;
      		
      		this.people_array.forEach(function(p) {
      			if(p.is_shareholder){
      				shareholder_count +=1;
      			}
      			
      			if(p.is_director){
      				director_count +=1;
      			}
      		
      		});
      		
      		if(this.person.position=="d" || this.person.position=="ds" ){
      			director_count +=1;
      		}
      		
      		if(this.person.position=="s" || this.person.position=="ds" ){
      			shareholder_count +=1;
      		}
      		
      		
      		if(director_count ==0 || shareholder_count==0){	
      			passed = false;
      		}
      		
      		if(director_count == 0 && shareholder_count>0){		
      			error_msg = "Please add at least one director";
      		}
      		else if(director_count > 0 && shareholder_count==0){		
      			error_msg = "Please add at least one shareholder";
      		}
      		else if(director_count==0  && shareholder_count==0){		
      			error_msg = "Please add at least one director and at least one shareholder";
      		}
      		
      		
      		if(passed){
 
				swal.showLoading();
		
				this.model.directors = this.directors_array;
				this.model.shareholders = this.shareholders_array;
				this.model.people = this.people_array;
				this.model.hasOwnAddress = this.hasOwnAddress;
				this.model.hasOwnLocalDirector = this.hasOwnLocalDirector;
				this.model.person = this.person;
				this.model.company = this.company;
				
				this.model.signup_type =  "incorp_and_appoint";
				
				this.model.org_id = this.$cs_org_id;
				
			
				let uri = this.$base_url+'/api/v1/c/save_onboarding';
				 ApiService.post(uri, this.model).then(response => {
					swal.close();
					//if(response.data.invoice){
					//	this.$router.push( '/view-invoice/'+	response.data.invoice.id);
					//}
					this.$router.push( '/incorporation');
				
				})
			}
			
			else{
			
			
					swal.fire({
							title: `Oops`,
							text:  error_msg,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
			
			
			
			} 
      },
      async validateCompanyDetails(){
      		//console.log(this.company.sources_arr);
      		this.company.ssic = this.ssic_info.code;
      		this.company.ssic_title = this.ssic_info.title;
      		
      		if(this.company.sources_arr.length==0){
      		
      				swal.fire({
							title: `Oops`,
							text: "Please select at least one source of funds.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      		 }
      		 
      		 if(this.hasOwnAddress && !(this.company.address_1 && this.company.zipcode)){
      		 	swal.fire({
							title: `Oops`,
							text: "Please complete your address.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
						  
				return false;
      		 }
      	

      		
			
			if(this.company.sources_arr.length!=0){
      			this.$refs.onboarding_wiz.nextTab();
      			 window.scrollTo(0,0);
      		}
      		
      	
      },
    },
    mounted() {
      	this.startIncorpForm() ;
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}

.stepTitle{
	font-size:17px;
	font-weight:lighter;

}


</style>














